var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -571.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Bank",
    transform: "translate(1970.000000, 571.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,27.5 L31,31.5 L1,31.5 L1,27.5 L31,27.5 Z M16,0.5 L32,7.5 C32,9.709 30.209,11.5 28,11.5 L28,11.5 L27,11.5 L27,25.5 L23,25.5 L23,11.5 L18,11.5 L18,25.5 L14,25.5 L14,11.5 L9,11.5 L9,25.5 L5,25.5 L5,11.5 L4,11.5 C1.791,11.5 0,9.709 0,7.5 L0,7.5 L16,0.5 Z M16,4.5 C14.896,4.5 14,5.396 14,6.5 C14,7.604 14.896,8.5 16,8.5 C17.104,8.5 18,7.604 18,6.5 C18,5.396 17.104,4.5 16,4.5 Z",
    id: 58
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsBank);
export default __webpack_public_path__ + "static/media/buildings-bank.aaf3b649.svg";
export { ForwardRef as ReactComponent };